import { negate } from 'lodash';

import { EMPTY_GUID } from '../services/wix-sdk-polyfill';
import {
  BI_UOU_ENDPOINT,
  BI_UOU_SRC,
  BI_USERS_ENDPOINT,
  BI_USERS_SRC,
  getCurrentUserRole,
  getCurrentUserSiteMemberId,
} from '@wix/communities-blog-client-common';
import createBiMiddleware from '../middleware/bi-middleware';
import { createBi, createUouBi, hasBiToken, getEventOrigin, getInstanceValue } from './bi-helpers';
import detectRoute from '../services/detect-route';

import { isInSite } from '../services/view-mode';
import { getConfig } from '../services/config';

const extendEventCommonFields = () => {
  const result = {
    biToken: getInstanceValue('biToken'),
    instance_id: getConfig().instanceId,
    referral_info: undefined,
  };
  if (result.biToken === EMPTY_GUID) {
    delete result.biToken;
  }
  if (result.instance_id === EMPTY_GUID) {
    delete result.instance_id;
  }
  return result;
};

const extendAppUouEvent = (eventDefaults) => (rawEvent, state) => {
  const event = { ...eventDefaults, ...rawEvent };

  return {
    ...extendEventCommonFields(),
    origin: event.origin || getEventOrigin({ detectRoute, event, state }),
    role: getCurrentUserRole(state),
    site_member_id: getCurrentUserSiteMemberId(state),
    visitor_id: getInstanceValue('aid') || getInstanceValue('uid'),
    ...event,
  };
};

const extendAppUsersEvent = (eventDefaults) => (rawEvent) => {
  const event = { ...eventDefaults, ...rawEvent };

  return {
    ...extendEventCommonFields(),
    role: 'owner',
    origin: event.origin,
    ...event,
  };
};

export const appUouBiMiddleware = ({ eventMap, eventDefaults = {}, useBeacon = true }) =>
  createBiMiddleware({
    bi: createUouBi({
      endpoint: BI_UOU_ENDPOINT,
      src: BI_UOU_SRC,
      useBeacon,
    }),
    eventMap,
    extendEvent: extendAppUouEvent(eventDefaults),
    shouldInvokeEvent: isInSite,
    shouldLogEvent: hasBiToken,
  });

export const appUsersBiMiddleware = ({ eventMap, eventDefaults = {}, shouldInvokeEvent = negate(isInSite) }) =>
  createBiMiddleware({
    bi: createBi({
      endpoint: BI_USERS_ENDPOINT,
      src: BI_USERS_SRC,
    }),
    eventMap,
    extendEvent: extendAppUsersEvent(eventDefaults),
    shouldInvokeEvent,
    shouldLogEvent: hasBiToken,
  });
